// MRZ scanner translations
export const MRZ_T = {
  hr: {
    title: "Skeniraj dokument", help: "Pomoć", close: "Zatvori",
    introTitle: "Što je MRZ kod?",
    introDesc: "MRZ (Machine Readable Zone) je posebna zona na vašem dokumentu koja sadrži kodirane podatke.",
    howLooks: "Kako izgleda:",
    idBack: "Stražnja strana", passportPage: "Stranica s fotografijom",
    introTip: "Fotografirajte SAMO dio dokumenta s MRZ kodom za najbolje rezultate!",
    startScan: "Razumijem, nastavi",
    takePhoto: "Fotografiraj", uploadPhoto: "Učitaj iz galerije",
    guideHint: "Pozicionirajte kod u okvir",
    analyze: "Očitaj podatke", newPhoto: "Nova fotografija",
    scanning: "Čitam MRZ kod...", scanningDetail: "Molimo pričekajte",
    scanningWait: "Obrada može potrajati 10-30 sekundi. Molimo nemojte zatvarati prozor.",
    success: "Uspješno očitano!", error: "MRZ kod nije pronađen",
    retry: "Pokušaj ponovno", errorTip: "Provjerite da je MRZ kod jasno vidljiv i dobro osvijetljen",
    cameraError: "Kamera nije dostupna",
    rateTitle: "Previše pokušaja", rateDesc: "Molimo pričekajte prije ponovnog skeniranja.",
    rateWait: "Pričekajte još:", seconds: "sekundi",
    scanCta: "Skeniraj dokument kamerom", scanCtaSub: "Brže popunite formu",
    orManual: "ili ispunite ručno",
  },
  en: {
    title: "Scan document", help: "Help", close: "Close",
    introTitle: "What is MRZ?",
    introDesc: "MRZ (Machine Readable Zone) is a special area on your document containing encoded data.",
    howLooks: "What it looks like:",
    idBack: "Back side", passportPage: "Photo page",
    introTip: "Photograph ONLY the part of the document with the MRZ code for best results!",
    startScan: "Got it, continue",
    takePhoto: "Take photo", uploadPhoto: "Upload from gallery",
    guideHint: "Position the code inside the frame",
    analyze: "Read data", newPhoto: "New photo",
    scanning: "Reading MRZ code...", scanningDetail: "Please wait",
    scanningWait: "Processing may take 10-30 seconds. Please do not close this window.",
    success: "Successfully scanned!", error: "MRZ code not found",
    retry: "Try again", errorTip: "Make sure the MRZ code is clearly visible and well lit",
    cameraError: "Camera not available",
    rateTitle: "Too many attempts", rateDesc: "Please wait before scanning again.",
    rateWait: "Wait", seconds: "seconds",
    scanCta: "Scan document with camera", scanCtaSub: "Fill the form faster",
    orManual: "or fill in manually",
  },
  de: {
    title: "Dokument scannen", help: "Hilfe", close: "Schließen",
    introTitle: "Was ist MRZ?",
    introDesc: "MRZ (Machine Readable Zone) ist ein spezieller Bereich auf Ihrem Dokument mit codierten Daten.",
    howLooks: "So sieht es aus:",
    idBack: "Rückseite", passportPage: "Fotoseite",
    introTip: "Fotografieren Sie NUR den Teil des Dokuments mit dem MRZ-Code für beste Ergebnisse!",
    startScan: "Verstanden, weiter",
    takePhoto: "Foto aufnehmen", uploadPhoto: "Aus Galerie hochladen",
    guideHint: "Code im Rahmen positionieren",
    analyze: "Daten auslesen", newPhoto: "Neues Foto",
    scanning: "Lese MRZ-Code...", scanningDetail: "Bitte warten",
    scanningWait: "Die Verarbeitung kann 10-30 Sekunden dauern. Bitte das Fenster nicht schließen.",
    success: "Erfolgreich gescannt!", error: "MRZ-Code nicht gefunden",
    retry: "Erneut versuchen", errorTip: "Stellen Sie sicher, dass der MRZ-Code klar sichtbar und gut beleuchtet ist",
    cameraError: "Kamera nicht verfügbar",
    rateTitle: "Zu viele Versuche", rateDesc: "Bitte warten Sie vor dem erneuten Scannen.",
    rateWait: "Warten Sie noch:", seconds: "Sekunden",
    scanCta: "Dokument mit Kamera scannen", scanCtaSub: "Formular schneller ausfüllen",
    orManual: "oder manuell ausfüllen",
  },
  it: {
    title: "Scansiona documento", help: "Aiuto", close: "Chiudi",
    introTitle: "Cos'è l'MRZ?",
    introDesc: "MRZ (Machine Readable Zone) è un'area speciale del documento con dati codificati.",
    howLooks: "Aspetto:",
    idBack: "Retro", passportPage: "Pagina foto",
    introTip: "Fotografare SOLO la parte del documento con il codice MRZ per migliori risultati!",
    startScan: "Capito, continua",
    takePhoto: "Scatta foto", uploadPhoto: "Carica da galleria",
    guideHint: "Posiziona il codice nel riquadro",
    analyze: "Leggi i dati", newPhoto: "Nuova foto",
    scanning: "Lettura del codice MRZ...", scanningDetail: "Attendere prego",
    scanningWait: "L'elaborazione può richiedere 10-30 secondi. Non chiudere la finestra.",
    success: "Scansione riuscita!", error: "Codice MRZ non trovato",
    retry: "Riprova", errorTip: "Verifica che il codice MRZ sia ben visibile e illuminato",
    cameraError: "Fotocamera non disponibile",
    rateTitle: "Troppi tentativi", rateDesc: "Attendere prima di scansionare di nuovo.",
    rateWait: "Attendere ancora:", seconds: "secondi",
    scanCta: "Scansiona documento con fotocamera", scanCtaSub: "Compila il modulo più velocemente",
    orManual: "o compila manualmente",
  },
};
